// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.loginForm {
  width: 50%;
  height: 90%;
  background-color: #FFFFFF;
  border-radius: 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  position: absolute;
  opacity: 0;
  transition: all 0.7s ease-out;
  min-width: 23rem;
  min-height: 70%;
  overflow: auto;
}
.loginForm.active {
  opacity: 1;
  z-index: 9;
}
.loginForm.next {
  opacity: 0.3;
  transform: translate(0, 9%) scale(0.9);
}
.loginForm p {
  font-size: 1rem;
  color: #232323;
}
.loginForm p span {
  cursor: pointer;
}
.loginForm p span:hover {
  text-decoration: underline;
}
.loginForm .logo {
  width: 11rem;
  margin-bottom: 2rem;
}
.loginForm .formFields {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow: auto;
  min-height: 60%;
}
.loginForm .formFields h1 {
  margin: 0;
  font-size: 2.18rem;
  font-weight: 700;
  color: #232323;
}
.loginForm .formFields p {
  margin: 0.6rem 0rem;
  font-size: 0.875rem;
  color: #232323;
  text-align: center;
}
.loginForm .formFields .userCredentials {
  flex: 1 1;
  overflow: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
}
.loginForm .formFields .userName {
  width: 80%;
  margin: 1rem 0rem;
}
.loginForm .formFields .userName input {
  width: 100%;
  height: 1.8rem;
  outline: none;
  border: none;
  border-bottom: 1px solid #CEEDF9;
  text-indent: 0.6rem;
  background-color: transparent;
  font-size: 0.875rem;
}
.loginForm .formFields .userPassword {
  width: 80%;
  position: relative;
  margin: 1rem 0rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.loginForm .formFields .userPassword input {
  width: 100%;
  height: 1.8rem;
  outline: none;
  border: none;
  border-bottom: 1px solid #CEEDF9;
  text-indent: 0.6rem;
  background-color: transparent;
  font-size: 0.875rem;
}
.loginForm .formFields .userPassword svg {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}
.loginForm .formFields .remPassword {
  display: flex;
  width: 80%;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
}
.loginForm .formFields .remPassword input[type=checkbox]:checked {
  height: 0.85rem;
  width: 0.85rem;
  appearance: none;
  background-color: #102c97;
  border-radius: 0.15rem;
}
.loginForm .formFields .remPassword input[type=checkbox]:checked::before {
  content: "✔";
  display: block;
  text-align: center;
  color: white;
  font-size: 0.6rem;
}
.loginForm .formFields .remPassword .forgotPassword {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 400;
  color: red;
  cursor: pointer;
}
.loginForm .formFields .remPassword .forgotPassword:hover {
  text-decoration: underline;
}
.loginForm .formFields .remPassword div {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 0.3rem;
}
.loginForm .formFields .remPassword div p {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 400;
  color: #232323;
}
.loginForm .formFields button {
  width: calc(80% + 0.6rem);
  height: 3.125rem;
  background-color: #102c97;
  color: white;
  outline: none;
  border: none;
  border-radius: 0.3rem;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Components/Login/LoginForm/LoginForm.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EAEI,UAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AACJ;AAAI;EACI,UAAA;EACA,UAAA;AAER;AAAI;EACI,YAAA;EACA,sCAAA;AAER;AAAI;EACI,eAAA;EACA,cAAA;AAER;AADQ;EACI,eAAA;AAGZ;AAFY;EACI,0BAAA;AAIhB;AAAI;EACI,YAAA;EACA,mBAAA;AAER;AAAI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AAER;AADQ;EACI,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAGZ;AADQ;EACI,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAGZ;AADQ;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;AAGZ;AADQ;EACI,UAAA;EACA,iBAAA;AAGZ;AAFY;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;EACA,6BAAA;EAEA,mBAAA;AAGhB;AAAQ;EACI,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAEZ;AADY;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;EAEA,6BAAA;EACA,mBAAA;AAEhB;AAAY;EACI,kBAAA;EAEA,MAAA;EACA,QAAA;EACA,eAAA;AAChB;AAEQ;EACI,aAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAAZ;AACY;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAChB;AAAgB;EACI,YAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAEpB;AACY;EACI,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;AAChB;AAAgB;EACI,0BAAA;AAEpB;AACY;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAChB;AAAgB;EACI,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAEpB;AAEQ;EACI,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAAZ","sourcesContent":[".loginForm{\n    // width: 35%;\n    width: 50%;\n    height: 90%;\n    background-color: #FFFFFF;\n    border-radius: 1.25rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 1.25rem;\n    position: absolute;\n    opacity: 0;\n    transition: all 0.7s ease-out;\n    min-width: 23rem;\n    min-height: 70%;\n    overflow: auto;\n    &.active{\n        opacity: 1;\n        z-index: 9;\n    }\n    &.next{\n        opacity: .3;\n        transform: translate(0, 9%) scale(0.9);\n    }\n    p{\n        font-size: 1rem;\n        color: #232323;\n        span{\n            cursor: pointer;\n            &:hover{\n                text-decoration: underline;\n            }\n        }\n    }\n    .logo{\n        width: 11rem;\n        margin-bottom: 2rem;\n    }\n    .formFields{\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        width: 100%;\n        overflow: auto;\n        min-height: 60%;\n        h1{\n            margin: 0;\n            font-size: 2.18rem;\n            font-weight: 700;\n            color: #232323;\n        }\n        p{\n            margin: .6rem 0rem;\n            font-size: 0.875rem;\n            color: #232323;\n            text-align: center;\n        }\n        .userCredentials{\n            flex: 1;\n            overflow: auto;\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: space-evenly;\n        }\n        .userName{\n            width: 80%;\n            margin: 1rem 0rem;\n            input{\n                width: 100%;\n                height: 1.8rem;\n                outline: none;\n                border: none;\n                border-bottom: 1px solid #CEEDF9;\n                text-indent: .6rem;\n                background-color: transparent;\n                // margin: .6rem 0rem;\n                font-size: 0.875rem;\n            }\n        }\n        .userPassword{\n            width: 80%;\n            position: relative;\n            margin: 1rem 0rem;\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            input{\n                width: 100%;\n                height: 1.8rem;\n                outline: none;\n                border: none;\n                border-bottom: 1px solid #CEEDF9;\n                text-indent: .6rem;\n                // margin: .6rem 0rem;\n                background-color: transparent;\n                font-size: 0.875rem;\n            }\n            svg{\n                position: absolute;\n                // transform: translateX(-100%);\n                top: 0;\n                right: 0;\n                cursor: pointer;\n            }\n        }\n        .remPassword{\n            display: flex;\n            width: 80%;\n            align-items: center;\n            justify-content: center;\n            margin-top: 1rem;\n            input[type='checkbox']:checked{\n                height: .85rem;\n                width: .85rem;\n                appearance: none;\n                background-color: #102c97;\n                border-radius: .15rem;\n                &::before{\n                    content: \"✔\";\n                    display: block;\n                    text-align: center;\n                    color: white;\n                    font-size: 0.6rem;\n                }\n            }\n            .forgotPassword{\n                margin: 0;\n                font-size: .8rem;\n                font-weight: 400;\n                color: red;\n                cursor: pointer;\n                &:hover{\n                    text-decoration: underline;\n                }\n            }\n            div{\n                display: flex;\n                align-items: center;\n                cursor: pointer;\n                gap: .3rem;\n                p{\n                    margin: 0;\n                    font-size: .8rem;\n                    font-weight: 400; \n                    color: #232323;\n                }\n            }\n        }\n        button{\n            width: calc(80% + .6rem);\n            height: 3.125rem;\n            background-color: #102c97;\n            color: white;\n            outline: none;\n            border: none;\n            border-radius: .3rem;\n            font-size: 1rem;\n            font-weight: 700;\n            cursor: pointer;\n            // margin-top: 10px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
